import apiAjax from "@/apis/user";
export default {
  namespaced: true,
  state: () => {
    return {
      // 最优简历
      resume: null,
    };
  },
  getters: {
    resumeId(state) {
      return state.resume?.resumeId;
    },
  },
  mutations: {
    // 给不同字段赋值,不缓存
    setValue(state, param) {
      Object.entries(param).forEach(([k, v]) => (state[k] = v));
    },
  },
  actions: {
    async loadBestResume({ commit }) {
      const { status, resultbody, message } = await apiAjax.getBestResume();
      if (status !== "1") {
        console.error(message);
        return;
      }
      console.log("教育请求")
      commit("setValue", { resume: resultbody.resumeId ? resultbody:null});
    },
  },
};
